<template>
  <div class="ccpay-login">
    <article class="nav-title" v-show="!this.$flag">
      <mt-header title="登錄验证">
        <!-- <a href="javascript:void(0);" slot="left" @click='goBack'>
                    <mt-button icon="back"></mt-button>
                </a> -->
            </mt-header>
        </article>
        <img src="../../../../static/img/back.png" style="visibility:hidden;" class='gu_nav_title_img_top'
            v-show='this.$flag' @click='goBack'>
        <div class="mobile_content pl-40 pr-40">
            <div class="email_content">
                <form action="">
                    <mt-field class="phoneNum phoneNumTull-lv"  :attr="{ maxlength: 6 }"   :placeholder="placeholder" type="tel" v-model="code"
                    
                    >
                      <span ref='spn'  class="captcha" v-show="veriphone" @click.stop='getPhoneGetCaptcha'>获取验证码</span>
                        </mt-field>
                    <!-- <div class='phoneError' ref='phone'></div> -->
                    <!-- <mt-field class="passInputWord"  placeholder="密码" type="password" v-model="password"
                      
                    > </mt-field> -->
                    <!-- <div class='passwordError' ref='password'></div> -->
                    <!-- <p class="c9 fz15 mt-15">
                        <a href="javascript:void(0)" class="c9 " @click='goPhoneForgetPasswordOne'>找回密码</a>
                        <a href="javascript:void(0)" class="fr c4a5" @click='goPhoneRegisterOne'>手机注册</a>
                    </p> -->
                    <mt-button class="mt-40" size="large" type="primary" @click.prevent="login" 
                        style='letterSpacing:5px;padding-right:0.2rem' >登錄</mt-button>
                    <!-- <mt-button class="mt-20" size="large" type="default" @click.prevent="goPhoneCaptchaLogin">手机验证码登錄</mt-button> -->
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions,mapState} from 'vuex'
// import {getCookie} from '../../../public/index'
import {getCookie,setCookie,ccpayUser,captchaDownTime} from '../../../public/index'
import { Indicator } from 'mint-ui';
export default {
    name:'Login',
    data() {
        return {
            code:'',
            placeholder:'',
            veriphone:false
            // password:'',
        }
    },
    mounted(){
         let tokentype = getCookie('elptokentype')
    if (tokentype == "Email") {
      this.placeholder = "请输入邮箱验证码";
                this.veriphone = true
            }else{
                this.placeholder = '请输入谷歌验证码'
                this.veriphone = false
            }
            this.$nextTick(() => {
                if(this.$refs.spn){
                if(this.$refs.spn.innerHTML=='获取验证码'){
                   captchaDownTime(this.$refs.spn)
                 }
                 }
            })

             
        // this.removeHtml()
    },
    computed :{
        ...mapState({
            //检测手机号的退後值
            // phoneHaveData:state=>state.phoneStore.phoneHaveData
        })
    },
    methods: {
        getCookie,
        setCookie,
        ccpayUser,
        // ...mapActions({
        //     getPhoneHaveAction:'phoneStore/getPhoneHaveAction',//检测手机号是否存在
        //     getPhoneLoginAction:'phoneStore/getPhoneLoginAction',//手机登錄
        //     getUserInfoAction:'phoneStore/getUserInfoAction'//用户个人資訊
        // }),
        goBack () {
            // let url =window.localStorage.getItem('url')
            // this.$router.push({
            //     path:url
            // })
        },
        getPhoneGetCaptcha(){
            if(this.$refs.spn.innerHTML=='获取验证码'){
                 captchaDownTime(this.$refs.spn)
              let phone =    window.localStorage.getItem('elptoken-phone')
              let psd =    window.localStorage.getItem('elptoken-password')
               this.$axios.post('/v1/login/loginV2S1',{
                 "account":phone,
                 "password":psd,
                 "country_code": "+86"}).then(res=>{
                    
                 })
                 
            }
            // this.verification = true
           
        },
        //先触发清空input值的事件
        removeHtml() {
            document.getElementsByClassName('mint-field-clear')[0].addEventListener('click',(event)=>{
                phoneVerification('',this.$refs.phone)
            }),
            document.getElementsByClassName('mint-field-clear')[1].addEventListener('click',(event)=>{
                passwordVerification('',this.$refs.password)
            })
        },
        login(){
            if(this.code==''){
                this.$Toast('请输入验证码')
                return
            }
            let token = getCookie('elptoken')
            let tokentype = getCookie('elptokentype')
            let obj = {
                    "data": {
                        "token": token
                    },
                    "validata": {
                       
                    }
            }
      if (tokentype == "Email") {
        obj.validata.emailCode = this.code;
            }else{
                 obj.validata.googleCode = this.code
            }
            // let headers =  {
            //       headers: {
            //         'user-agent': 'webapp/ '
            //      }
            //  }
             Indicator.open();
            this.$axios.post('/v1/login/loginV2SE',obj).then(res=>{
                 Indicator.close();
                if(res.code==0){
                    setCookie('ccpay-token',res.data.token,30)
                    this.$Toast('登錄成功')
                    ccpayUser(JSON.stringify(res.data.userInfo),30)
                    this.$router.push({
                            path:'/index'
                    })
                }else{
                    this.$Toast(res.msg)
                }
            })
        }
        // //手机按键事件
        // phoneInput () {
        //     if(this.$refs.phone.innerHTML!=''){
        //         this.$refs.phone.innerHTML='',
        //         this.$refs.phone.style.borderTop='none'
        //     }
        // },
        // //密码按键事件
        // passwordInput () {
        //     if(this.$refs.password.innerHTML!=''){
        //         this.$refs.password.innerHTML='',
        //         this.$refs.password.style.borderTop='none'
        //     }
        // },
    },
    components:{
    }
}
</script>
<style lang='scss' scoped>
.ccpay-login{
    height: 100%;
    background: white;
}
.email_content{
    margin-top:4.5rem;
}
.email_content h3{
    margin-bottom:3rem;
}
.email_content form .phoneNum {
}
.mint-cell-value{
    width: 10rem
}
</style>





// WEBPACK FOOTER //
// src/components/login/phone/Login.vue